import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITimelineSkeletonItemProps from "./type";
import stylesheet, {
    TIMELINE_SKELETON_TITLE_WIDTHS,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    getTimelineMeasures
} from "../../stylesheet";
import Skeleton from "../../../skeleton";

const TimelineSkeletonItem: FC<ITimelineSkeletonItemProps> = ({
    customTheme,
    isLast,
    index,
    size
}) => {
    const {
        controlPaddings,
        shapeConfigs,
        avatarSizes,
        typography,
        iconSizes,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const measures = getTimelineMeasures({
        shapeConfigs,
        avatarSizes,
        typography,
        iconSizes,
        spaces,
        size
    });

    const {
        container: containerDynamicStyle,
        content: contentDynamicStyle,
        item: itemDynamicStyle
    } = useStyles({
        markerSize: measures.markerSize,
        lineHeight: measures.lineHeight,
        gap: measures.gap,
        controlPaddings,
        spaces
    });

    return <View
        style={isLast ? undefined : itemDynamicStyle}
    >
        <View
            style={[
                stylesheet.container,
                containerDynamicStyle
            ]}
        >
            <Skeleton
                size={measures.markerSize}
                customTheme={customTheme}
                variant="circle"
            />
            <View
                style={[
                    stylesheet.content,
                    contentDynamicStyle
                ]}
            >
                <Skeleton
                    width={TIMELINE_SKELETON_TITLE_WIDTHS[index % TIMELINE_SKELETON_TITLE_WIDTHS.length]}
                    typography="bodyMediumSize"
                    customTheme={customTheme}
                    variant="text"
                />
                <Skeleton
                    width={shapeConfigs.sideListWidth}
                    typography="bodySmallSize"
                    customTheme={customTheme}
                    variant="text"
                />
            </View>
        </View>
    </View>;
};
export default TimelineSkeletonItem;
